module.exports = __webpack_public_path__ + "img/logo_black.70db5551.png";